import { render } from "./CourseAddQuestionCard.vue?vue&type=template&id=41d244c1&scoped=true"
import script from "./CourseAddQuestionCard.vue?vue&type=script&lang=js"
export * from "./CourseAddQuestionCard.vue?vue&type=script&lang=js"

import "./CourseAddQuestionCard.vue?vue&type=style&index=0&id=41d244c1&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d244c1"]])

export default __exports__